<!-- Create Recipient Modal -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50"
  *ngIf="showCreateModal"
>
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-lg font-semibold text-gray-900">Create Recipient</h2>
      <button (click)="closeCreateModal()" class="text-gray-400 hover:text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 01-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.586 10 3.636 5.05a1 1 0 111.414-1.414L10 8.586z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>

    <form (ngSubmit)="createRecipient()" #recipientForm="ngForm" class="space-y-4 max-h-[75vh] overflow-y-auto pr-2">

      <!-- First & Last Name -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">Name</label>
          <input type="text" name="first_name" [(ngModel)]="newRecipient.name"
            #name="ngModel" required
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': name.invalid && name.touched}" />
          <p *ngIf="name.invalid && name.touched" class="text-xs text-red-500 mt-1">
            Name is required.
          </p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Address</label>
          <input type="text" name="last_name" [(ngModel)]="newRecipient.address"
            #address="ngModel" required
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': address.invalid && address.touched}" />
          <p *ngIf="address.invalid && address.touched" class="text-xs text-red-500 mt-1">
            Address is required.
          </p>
        </div>
      </div>

      <!-- Actions -->
      <div class="mt-6 flex justify-end gap-3 border-t border-gray-200 pt-4">
        <button type="button" (click)="closeCreateModal()"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
          Cancel
        </button>
        <button type="submit"
          class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-500 disabled:opacity-50"
          [disabled]="recipientForm.invalid">
          Save
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Loader -->
<div class="flex items-center justify-center h-64" *ngIf="loading">
  <svg class="animate-spin h-8 w-8 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4z"></path>
  </svg>
</div>

<!-- Main Table -->
<div *ngIf="!loading">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-2xl font-semibold text-gray-900">USDC Recipients</h1>
    </div>
    <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
      <button type="button" (click)="openCreateModal()"
        class="inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500">
        + Create Recipient
      </button>
    </div>
  </div>

  <div class="mt-8 overflow-x-auto shadow rounded-lg">
    <table class="min-w-full divide-y divide-gray-300 bg-white">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Name</th>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Address</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr *ngFor="let recipient of recipients" class="hover:bg-gray-50">
          <td class="px-3 py-3 text-sm text-gray-700">{{ recipient.name }}</td>
          <td class="px-3 py-3 text-sm text-gray-700">{{ recipient.address }}</td>
        </tr>
      </tbody>
    </table>

    <ng-template #noRecipients>
      <div class="text-center py-10 text-gray-500">
        <p>No recipients found.</p>
      </div>
    </ng-template>
  </div>

  <!-- Pagination -->
  <div class="mt-6 flex justify-center">
    <nav class="inline-flex rounded-md shadow-sm">
      <button (click)="goToPreviousPage()" [disabled]="!previousPageUrl"
        class="px-3 py-2 border border-gray-300 rounded-l-md bg-white text-sm hover:bg-gray-50 disabled:opacity-50">
        ‹
      </button>
      <button *ngFor="let page of pageNumbers"
        (click)="page !== '...' && loadRecipients(page)"
        [disabled]="page === '...' || currentPage === page"
        [ngClass]="{
          'bg-indigo-600 text-white': currentPage === page,
          'bg-white text-gray-700': currentPage !== page
        }"
        class="px-4 py-2 border border-gray-300 text-sm hover:bg-gray-50">
        {{ page }}
      </button>
      <button (click)="goToNextPage()" [disabled]="!nextPageUrl"
        class="px-3 py-2 border border-gray-300 rounded-r-md bg-white text-sm hover:bg-gray-50 disabled:opacity-50">
        ›
      </button>
    </nav>
  </div>
</div>
